import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './one-field.component.html',
  styleUrls: ['./one-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OneFieldComponent {
  x_data!: any;

  constructor(
    public dialogRef: MatDialogRef<OneFieldComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.x_data = data?.data ?? {};
  }

  save() {
    this.dialogRef.close(this.x_data.input?.trim());
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
